export default function ({ store, redirect }) {
  const { quizList, currentIndex } = store.state.quiz;

  if (!quizList || !quizList.length || !quizList[currentIndex]) {
    return redirect({ path: `/quiz/start` });
  }
}
